module.exports = __webpack_public_path__ + "media/images/asvh_logo-d93be2763556d58c2525b5cb10c8983f.png";